import { render } from "./AppUpdateNotification.vue?vue&type=template&id=be02a60a&scoped=true"
import script from "./AppUpdateNotification.vue?vue&type=script&lang=js"
export * from "./AppUpdateNotification.vue?vue&type=script&lang=js"

import "./AppUpdateNotification.vue?vue&type=style&index=0&id=be02a60a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be02a60a"]])

export default __exports__